import styled from 'styled-components';
import {basicColor} from '../../../../../styles/template';
import SuccessMessage from '../SuccessMessage/SuccessMessage';

const WarningMessage = styled(SuccessMessage)`
    color: ${basicColor.accentDark};
    background: ${basicColor.accentTransparent};
`;

export default WarningMessage